<div class="relative flex flex-col w-full h-full md:w-128">
  <!-- Title -->
  @if (data.title) {
    <div
      class="flex flex-col items-center sm:items-start -mx-6 -mt-6 p-8 space-y-1 text-center sm:text-left bg-primary-800">
      <div class="text-xl leading-6 font-medium text-on-primary-800" [innerHTML]="data.title"></div>
    </div>
  }

  <!-- Dismiss button -->
  @if (data.dismissible) {
    <div class="absolute top-0 right-0 pt-4 pr-4">
      <button mat-icon-button [matDialogClose]="undefined">
        <mat-icon class="text-secondary" svgIcon="mat_outline:close" />
      </button>
    </div>
  }

  <!-- Content -->
  <div class="flex flex-col sm:flex-row flex-auto items-center sm:items-start py-8">
    <!-- Icon -->
    @if (data?.icon?.show) {
      <div
        class="flex flex-0 items-center justify-center w-10 h-10 sm:mr-4 rounded-full"
        [ngClass]="{
          'text-primary-600 bg-primary-100 dark:text-primary-50 dark:bg-primary-600': data.icon.color === 'primary',
          'text-accent-600 bg-accent-100 dark:text-accent-50 dark:bg-accent-600': data.icon.color === 'accent',
          'text-warn-600 bg-warn-100 dark:text-warn-50 dark:bg-warn-600': data.icon.color === 'warn',
          'text-gray-600 bg-gray-100 dark:text-gray-50 dark:bg-gray-600': data.icon.color === 'basic',
          'text-info bg-blue-100 dark:text-blue-50 dark:bg-blue-600': data.icon.color === 'info',
          'text-success bg-green-100 dark:text-green-50 dark:bg-green-500': data.icon.color === 'success'
        }">
        <mat-icon class="text-current" [svgIcon]="data.icon.name" />
      </div>
    }

    <!-- Message -->
    @if (data.message) {
      <div class="flex flex-col items-center sm:items-start mt-4 sm:mt-0 space-y-1 text-center sm:text-left">
        <div class="text-secondary" [innerHTML]="data.message"></div>
      </div>
    }
  </div>

  <!-- Actions -->
  @if (data?.actions?.confirm?.show || data?.actions?.cancel?.show) {
    <div
      class="flex items-center justify-center sm:justify-end -mx-6 -mb-6 p-8 space-x-3 bg-gray-50 dark:bg-black dark:bg-opacity-10">
      <!-- Cancel -->
      @if (data?.actions?.cancel?.show) {
        <button mat-stroked-button [matDialogClose]="false">
          {{ data?.actions?.cancel?.label }}
        </button>
      }

      <!-- Confirm -->
      @if (data?.actions?.confirm?.show) {
        <button mat-flat-button [color]="data.actions.confirm.color" [matDialogClose]="true">
          {{ data.actions.confirm.label }}
        </button>
      }
    </div>
  }
</div>
